import { render, staticRenderFns } from "./PolizasFinanzasTabs.vue?vue&type=template&id=316cd88e&scoped=true&"
import script from "./PolizasFinanzasTabs.vue?vue&type=script&lang=js&"
export * from "./PolizasFinanzasTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316cd88e",
  null
  
)

export default component.exports